import { Cached } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { type UseQueryResult } from '@tanstack/react-query';

import { formatTime } from '../../utils/dateFormat/dateFormat';

type PageTitleProps = {
  readonly title: string;
  readonly subtitle?: string;
  readonly reloadQuery?: UseQueryResult<unknown[], unknown>;
};

export const PageTitle = ({ title, subtitle, reloadQuery }: PageTitleProps) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
    <Stack direction="column" spacing={1}>
      <Typography variant="headingXs">{title}</Typography>
      {subtitle && (
        <Typography variant="label" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Stack>
    {reloadQuery && (
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="label" color="text.secondary" fontWeight={200}>
          Zuletzt aktualisiert heute,{' '}
          {/* eslint-disable-next-line @eslint-react/purity -- added during migration to ban-pdk. please solve issue or explain disable-reason here */}
          {formatTime(reloadQuery.dataUpdatedAt ? new Date(reloadQuery.dataUpdatedAt) : new Date())}
        </Typography>
        <Button
          variant="contained"
          onClick={async () => await reloadQuery.refetch({ cancelRefetch: false })}
          size="small"
          sx={{ py: '8px' }}
        >
          <Cached />
          Neu laden
        </Button>
      </Stack>
    )}
  </Stack>
);
